import CalculatorLayout from '../layouts/CalculatorLayout';
import CalculatorPage from '../pages/Calculator/CalculatorPage';
import ChooseVehiclePage from '../pages/Calculator/ChooseVehiclePage';
import ViewShortlistPage from '../pages/Calculator/ViewShortlistPage';
import VehicleResultPage from '../pages/Calculator/VehicleResultPage';
import VehicleProductPage from '../pages/Calculator/VehicleProductPage';
import EnquireNowPage from '../pages/Calculator/EnquireNowPage';
import EnquireNowSuccessPage from '../pages/Calculator/EnquireNowSuccessPage';

export default [
  {
    path: '/calculator',
    name: 'calculator',
    meta: {
      layout: CalculatorLayout,
      skipAuthentication: true
    },
    component: CalculatorPage,
    children: [
      {
        name: 'calculatorSearch',
        path: '',
        meta: {
          layout: CalculatorLayout,
          skipAuthentication: true
        },
        component: ChooseVehiclePage
      },
      {
        name: 'calculatorResults',
        path: 'results',
        meta: {
          layout: CalculatorLayout,
          skipAuthentication: true
        },
        component: VehicleResultPage
      },
      {
        name: 'vehicleProduct',
        path: 'vehicles/:vehicleMake/:vehicleModel/:catalogVehicleId/:vehicleTrim?/:vehicleDrivetrain?',
        meta: {
          layout: CalculatorLayout,
          skipAuthentication: true
        },
        component: VehicleProductPage
      },
      {
        name: 'calculatorShortlists',
        path: 'shortlists',
        meta: {
          layout: CalculatorLayout,
          skipAuthentication: true
        },
        component: ViewShortlistPage
      },
      {
        name: 'calculatorRegistration',
        path: 'enquire-now',
        meta: {
          layout: CalculatorLayout,
          skipAuthentication: true
        },
        component: EnquireNowPage
      },
      {
        name: 'calculatorRegistrationSuccess',
        path: 'thank-you',
        meta: {
          layout: CalculatorLayout,
          skipAuthentication: true
        },
        component: EnquireNowSuccessPage
      }
    ]
  }
];
